import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
import _uniqueId from "lodash/uniqueId";
import _union from "lodash/union";
import _sortBy2 from "lodash/sortBy";
import _orderBy from "lodash/orderBy";
import _isString from "lodash/isString";
import _isMatchWith from "lodash/isMatchWith";
import _isMatch from "lodash/isMatch";
import _isEqual from "lodash/isEqual";
import _isArray from "lodash/isArray";
import _escapeRegExp from "lodash/escapeRegExp";
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { action, computed, observable } from 'mobx';
import safelyParseJSON from '@kentik/ui-shared/util/safelyParseJson';
import api from 'core/util/api';
import collatePromises from 'core/util/collatePromises';
import { processLargeArrayAsync } from 'core/util';
import GenericModel, { Model } from 'core/model/Model';

/**
 * The set of keys that make up the type underlying a targeted model
 */

/**
 * The acceptable sort states for a given Collection
 */

/**
 * The acceptable grouping states for a given Collection.
 */

/**
 * The constructor of the Model owned by this Collection.
 */

/**
 * Like regular Model JSON except with additional fields that come from the API. Note that all
 * API fields are marked as optional - this means that you can also pass in regular objects and
 * everything will still function!
 */

/**
 * Every form of acceptable Model input. This includes:
 * - the Model itself,
 * - ModelConstructorArgs - just the JSON required to construct the object.
 * - Model Type (i.e. Model.attributes)
 *   - technically a superset of ModelConstructorArgs but TS doesn't automatically understand that!
 *
 * Note that sometimes TS errors can be confusing here when it tests against the Model.
 * Consider asserting InferModelConstructorArgs<MOD>.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var Collection = (_dec = observable.shallow, _dec2 = observable.ref, _class = /*#__PURE__*/function () {
  function Collection() {
    var _this = this;
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var _options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Collection);
    _initializerDefineProperty(this, "requestStatus", _descriptor, this);
    this.models = observable.array([], {
      deep: false
    });
    this.modelById = {};
    /**
     * list of fields that, when used to sort, will trigger a server-side data load
     *
     * Ideally this would be protected and readonly but we do set it externally in some cases
     */
    this.serverSortableFields = [];
    // list of fields that, when used to sort, will need ui-driven logic to create a sorting filter for API
    this.uiSortLogicFields = [];
    _initializerDefineProperty(this, "error", _descriptor2, this);
    this.id = _uniqueId('c_');
    _initializerDefineProperty(this, "filterState", _descriptor3, this);
    _initializerDefineProperty(this, "activePresetFilter", _descriptor4, this);
    _initializerDefineProperty(this, "discreteFilters", _descriptor5, this);
    _initializerDefineProperty(this, "sortState", _descriptor6, this);
    _initializerDefineProperty(this, "groupBy", _descriptor7, this);
    _initializerDefineProperty(this, "selected", _descriptor8, this);
    _initializerDefineProperty(this, "hasFetched", _descriptor9, this);
    _initializerDefineProperty(this, "original", _descriptor0, this);
    _initializerDefineProperty(this, "lastUpdated", _descriptor1, this);
    _initializerDefineProperty(this, "lastFetched", _descriptor10, this);
    _initializerDefineProperty(this, "useAsyncAdd", _descriptor11, this);
    this.fetchPromise = null;
    _initializerDefineProperty(this, "totalCount", _descriptor12, this);
    _initializerDefineProperty(this, "hasMoreResults", _descriptor13, this);
    this.threeWaySort = void 0;
    this.store = void 0;
    // eslint-disable-next-line no-use-before-define
    this.parent = void 0;
    this.getSortValue = void 0;
    _initializerDefineProperty(this, "fetchCount", _descriptor14, this);
    this.lastData = void 0;
    _initializerDefineProperty(this, "cachedResults", _descriptor15, this);
    this.hashModelsById = function () {
      var modelHash = {};
      _this.get().forEach(function (model) {
        if (model && model.id) {
          modelHash[model.id] = model;
        }
      });
      _this.modelById = modelHash;
    };
    /**
     * Creates a new model instance with the given attributes
     */
    this.build = function (attributes) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$select = options.select,
        select = _options$select === void 0 ? false : _options$select,
        _options$deserialize = options.deserialize,
        deserialize = _options$deserialize === void 0 ? true : _options$deserialize;
      var ModelClass = _this.model;
      var model = new ModelClass();
      model.store = _this.store;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      model.collection = _this;
      model.set(deserialize ? model.deserialize(attributes) : attributes);
      if (select) {
        _this.selected = model;
      }
      return model;
    };
    this.generateSelectOptions = function (_ref) {
      var _ref$valueKey = _ref.valueKey,
        valueKey = _ref$valueKey === void 0 ? 'id' : _ref$valueKey,
        labelKey = _ref.labelKey,
        sortBy = _ref.sortBy,
        _ref$unfiltered = _ref.unfiltered,
        unfiltered = _ref$unfiltered === void 0 ? false : _ref$unfiltered;
      var models = unfiltered ? _this.unfiltered : _this.models;
      var options = models.map(function (model) {
        return _objectSpread({
          value: model.get(valueKey) || model[valueKey],
          label: labelKey ? model.get(labelKey) : model.get(valueKey)
        }, model.get());
      });
      if (sortBy) {
        return _orderBy(options, sortBy);
      }
      return options;
    };
    _initializerDefineProperty(this, "unselectAll", _descriptor16, this);
    _initializerDefineProperty(this, "select", _descriptor17, this);
    _initializerDefineProperty(this, "clearSelection", _descriptor18, this);
    _initializerDefineProperty(this, "setLastUpdated", _descriptor19, this);
    _initializerDefineProperty(this, "setLastFetched", _descriptor20, this);
    _initializerDefineProperty(this, "setRequestStatus", _descriptor21, this);
    /**
     * Adds one or more models to the collection. Accepts an array of models/raw objects or a simple model/object.
     * Returns the added models.
     *
     * DO NOT CALL INSIDE A LOOP as this is somewhat expensive. Instead, prefer constructing complete collection and passing that in.
     *
     * @param data technically you can pass in single objects as well but object[] is better for type hinting and functionally identical otherwise
     */
    _initializerDefineProperty(this, "add", _descriptor22, this);
    _initializerDefineProperty(this, "remove", _descriptor23, this);
    /**
     * Sets the model(s) in the collection. Accepts an array of models/raw objects or a simple model/object.
     */
    _initializerDefineProperty(this, "set", _descriptor24, this);
    /**
     * Creates a model object of the type the Collection instance uses with the provided data
     * optionally selecting it (this is the default behavior). The resultant model is not added
     * to the collection!
     */
    _initializerDefineProperty(this, "forge", _descriptor25, this);
    this.getServerSortBy = function () {
      var canServerSort = _this.sortFieldIsServerSortable || typeof _this.groupBy === 'string' && _this.serverSortableFields.includes(_this.groupBy);
      var sortBy;
      if (canServerSort) {
        // first sorting is done by grouping in terms of api search
        sortBy = typeof _this.groupBy === 'string' && _this.groupBy || '';
        if (_this.sortState.field && _this.sortFieldIsServerSortable) {
          // second sorting is done by actual sort on a specific field - comma separated
          // format: groupBy,sortBy:order
          sortBy = sortBy ? "".concat(sortBy, ",").concat(_this.sortState.field, ":").concat(_this.sortState.direction) : "".concat(_this.sortState.field, ":").concat(_this.sortState.direction);
        }
      }
      return sortBy;
    };
    this.loadMoreItems = function (_ref2) {
      var startIndex = _ref2.startIndex,
        _ref2$reset = _ref2.reset,
        reset = _ref2$reset === void 0 ? false : _ref2$reset,
        _ref2$force = _ref2.force,
        force = _ref2$force === void 0 ? false : _ref2$force;
      var sortBy = _this.getServerSortBy();
      var isUnfiltered = _this.size === _this.unfilteredSize;
      // If there's a collection filter, use the unfiltered size as our offset
      var offset = isUnfiltered ? startIndex : _this.unfilteredSize;
      var hadMoreResults = _this.hasMoreResults;
      if (reset) {
        _this.reset();
      }

      // this.totalCount represents total possible results for a query.
      // If our offset is greater/equal to that, no need to kick off another fetch.
      if (_this.totalCount != null && offset && offset >= _this.totalCount && !hadMoreResults) {
        return Promise.resolve(null);
      }
      return _this.fetch({
        pagedFetch: !!startIndex,
        data: {
          force: force,
          offset: offset,
          sortBy: sortBy === null || sortBy === void 0 ? void 0 : sortBy.toString()
        }
      });
    };
    var _options$activePreset = _options.activePresetFilter,
      activePresetFilter = _options$activePreset === void 0 ? this.defaultPresetFilter : _options$activePreset,
      _options$sortState = _options.sortState,
      sortState = _options$sortState === void 0 ? this.defaultSortState : _options$sortState,
      _options$discreteFilt = _options.discreteFilters,
      discreteFilters = _options$discreteFilt === void 0 ? this.defaultDiscreteFilters : _options$discreteFilt,
      _options$groupBy = _options.groupBy,
      currGroupBy = _options$groupBy === void 0 ? this.defaultGroupBy : _options$groupBy,
      getSortValue = _options.getSortValue,
      _options$hasFetched = _options.hasFetched,
      hasFetched = _options$hasFetched === void 0 ? false : _options$hasFetched,
      _models = _options.models,
      _options$threeWaySort = _options.threeWaySort,
      threeWaySort = _options$threeWaySort === void 0 ? false : _options$threeWaySort,
      _options$store = _options.store,
      store = _options$store === void 0 ? null : _options$store;
    if (store) {
      this.store = store;
    }

    // allows for custom getSortValue in generic Collection usage
    if (typeof getSortValue === 'function') {
      this.getSortValue = getSortValue;
    }

    // manual bind for converted arrow functions. Allows subclasses to override but keeps arrow function "this" behavior.
    this.processData = this.processData.bind(this);
    this.reset = this.reset.bind(this);
    this.activePresetFilter = activePresetFilter;
    this.threeWaySort = threeWaySort;
    this.sortState = sortState;
    this.discreteFilters = discreteFilters;
    this.groupBy = currGroupBy;
    if (_models) {
      this.models.replace(_models);
      this.hashModelsById();
    } else {
      this.set(data);
    }

    // Most common use case for this would be when a collection is initialized with data upfront.
    // When a collection is initialized with data and a PresetFilterButton group is applied to it,
    // you may encounter a situation where the filter buttons all become disabled when filtering by a property
    // that yields 0 results. Setting this option will prevent that.
    this.hasFetched = hasFetched;
    this.parent = _options.parent || undefined;
  }
  return _createClass(Collection, [{
    key: "selectedArray",
    get: function get() {
      return !this.selected || Array.isArray(this.selected) ? this.selected : [this.selected];
    }
  }, {
    key: "urlPaths",
    get: function get() {
      return undefined;
    }
  }, {
    key: "fetchMethod",
    get: function get() {
      return 'get';
    }
  }, {
    key: "queuedFetchKey",
    get: function get() {
      return null;
    }
  }, {
    key: "defaultSortState",
    get: function get() {
      return {};
    }
  }, {
    key: "defaultDiscreteFilters",
    get: function get() {
      return [];
    }
  }, {
    key: "baseSort",
    get: function get() {
      return null;
    }
  }, {
    key: "secondarySort",
    get: function get() {
      return null;
    }
  }, {
    key: "defaultGroupBy",
    get: function get() {
      return null;
    }
  }, {
    key: "defaultPresetFilter",
    get: function get() {
      return this.presetFilters && this.presetFilters.find(function (filter) {
        return filter["default"];
      }) || undefined;
    }
  }, {
    key: "presetFilters",
    get: function get() {
      return false;
    }

    /**
     * Appears entirely unused? Should probably be deleted but I'm leaving it in for now.
     * @private
     * @deprecated should be removed if this continues to go unused
     */
  }, {
    key: "discreteFiltersTypes",
    get: function get() {
      return this.discreteFilters.map(function (filter) {
        return filter.type;
      });
    }
  }, {
    key: "minFetchInterval",
    get: function get() {
      return 300000;
    }

    /**
     * Returns the URL where the model's resource would be located on the server.
     */
  }, {
    key: "url",
    get: function get() {
      return undefined;
    }

    /**
     * Specifies the model class for that collection
     */
  }, {
    key: "toJS",
    value:
    /**
     * Returns this Collection's Models as raw JSON.
     */
    function toJS() {
      return this.models.map(function (model) {
        return model.toJS();
      });
    }

    /**
     * Describes the behavior of what a server side sort means, can be overridden at the collection level
     */
  }, {
    key: "serverSortFn",
    value: function serverSortFn() {
      return this.loadMoreItems({
        startIndex: 0,
        force: true,
        reset: true
      });
    }
  }, {
    key: "isRequestActive",
    value:
    /**
     * Questions whether the request exists and matches a certain label
     * If no label are passed it will check if any requests are active.
     */
    function isRequestActive(label) {
      if (this.requestStatus === 'awaitingRequest') {
        return true;
      }
      if (!label) {
        return this.requestStatus !== null;
      }
      return !!this.requestStatus && this.requestStatus === label;
    }

    /**
     * Whether the collection is empty
     */
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.models.length === 0;
    }

    /**
     * Get a resource at a given position
     */
  }, {
    key: "at",
    value: function at(index) {
      if (index < 0 || index >= this.size || !this.models[index]) {
        console.warn("No model found at index ".concat(index));
        return false;
      }
      return this.models[index];
    }
  }, {
    key: "get",
    value:
    /**
     * Get a resource with the given id or uuid or if no id is provided, will return all the models
     */
    function get(id) {
      if (id !== undefined) {
        return this.modelById[id];
      }
      var models = this.original || this.models;
      return models.slice();
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      return this.models[Symbol.iterator]();
    }
  }, {
    key: "each",
    value: function each(iterator) {
      this.models.forEach(iterator);
    }
  }, {
    key: "map",
    value: function map(iterator) {
      return this.models.map(iterator);
    }
  }, {
    key: "some",
    value: function some(iterator) {
      return this.models.some(iterator);
    }
  }, {
    key: "every",
    value: function every(iterator) {
      return this.models.every(iterator);
    }
  }, {
    key: "reduce",
    value: function reduce(iterator, initialValue) {
      return this.models.reduce(iterator, initialValue);
    }
  }, {
    key: "slice",
    value: function slice(start, end) {
      return this.models.slice(start, end);
    }

    /**
     * Standard JS array.find()
     */
  }, {
    key: "find",
    value:
    /**
     * Finds an element with the given matcher
     */
    function find(query, customizer) {
      // standard JS array.find()
      if (typeof query === 'function') {
        return this.models.find(query);
      }
      // lodash predicate find
      return this.models.find(function (model) {
        return customizer ? _isMatchWith(model.attributes, query, customizer) : _isMatch(model.attributes, query);
      });
    }
  }, {
    key: "group",
    value: function group(value) {
      var loadMore = this.groupBy !== value && (value ? this.serverSortableFields.includes(value) : this.sortFieldIsServerSortable);
      this.groupBy = value;

      // if grouping by a new column that's server sortable, we also need to re-fetch
      if (loadMore) {
        this.loadMoreItems({
          startIndex: 0,
          force: true,
          reset: true
        });
      }
    }
  }, {
    key: "isTreeGroupBy",
    get: function get() {
      return false;
    }
  }, {
    key: "groupedData",
    get: function get() {
      var _this2 = this;
      if (!this.groupBy) {
        return {};
      }
      var groups = {};
      this.models.forEach(function (model) {
        var _this2$groupBy, _this2$groupBy2;
        // add ability to set this.groupBy to object. Expecting type(string) and groupByFn(function) properties.
        var group = _typeof(_this2.groupBy) === 'object' ? (_this2$groupBy = _this2.groupBy) === null || _this2$groupBy === void 0 ? void 0 : _this2$groupBy.groupByFn(model) : (_this2$groupBy2 = model[_this2.groupBy]) !== null && _this2$groupBy2 !== void 0 ? _this2$groupBy2 : model.get(_this2.groupBy);
        if (Array.isArray(group)) {
          if (group.length > 0) {
            // add model to multiple groups (for labels, etc.)
            group.forEach(function (g) {
              var _groups$g;
              (_groups$g = groups[g]) !== null && _groups$g !== void 0 ? _groups$g : groups[g] = [];
              groups[g].push(model);
            });
          } else {
            var _groups$None;
            (_groups$None = groups.None) !== null && _groups$None !== void 0 ? _groups$None : groups.None = [];
            groups.None.push(model);
          }
        } else {
          var _groups$group;
          (_groups$group = groups[group]) !== null && _groups$group !== void 0 ? _groups$group : groups[group] = [];
          groups[group].push(model);
        }
      });
      return groups;
    }
  }, {
    key: "sortedGroupKeys",
    get: function get() {
      var _this3 = this;
      if (!this.groupBy) {
        return [];
      }
      var groupedModels = this.groupedData;

      // This assumed ALL the models are sorted, then this sorts the group indexes based on their current order in the whole collection
      return _sortBy2(Object.keys(groupedModels), function (groupKey) {
        return _this3.models.indexOf(groupedModels[groupKey][0]);
      });
    }
  }, {
    key: "move",
    value: function move(oldIndex, newIndex) {
      this.models.splice(newIndex, 0, this.models.splice(oldIndex, 1)[0]);
    }
  }, {
    key: "sort",
    value: function sort(field, direction) {
      var _this4 = this;
      var sortField = this.sortState.field;
      var sortDir = this.sortState.direction;

      // just clear the sort if the user clicked the same field while already sorted descending or sorted by the default direction
      if (this.threeWaySort && sortField === field && sortDir && (this.defaultSortState.direction && sortDir !== this.defaultSortState.direction || !this.defaultSortState.direction && sortDir === 'desc')) {
        this.clearSort();
        return;
      }

      // If a field was explicitly passed, use it
      if (field !== undefined) {
        sortField = field;
        sortDir = direction || this.defaultSortState.direction || 'asc';

        // If the field passed was the same as current, toggle the direction (or turn off)
        if (field === this.sortState.field && !direction) {
          sortDir = this.sortState.direction === 'asc' ? 'desc' : 'asc';
        }
      }
      if (sortField) {
        if (this.sortState.field !== sortField || this.sortState.direction !== sortDir) {
          this.sortState = {
            field: sortField,
            direction: sortDir
          };
        }

        // no need to sort locally if we already sorted on the server
        if (field === undefined && this.sortFieldIsServerSortable) {
          return;
        }
        this.original = this.get();
        var iteratees = [];
        var orders = [];
        var baseSortFn;
        var sortFn;
        var getSortValue = this.getSortValue;
        if (getSortValue) {
          baseSortFn = function baseSortFn(model) {
            var _this4$baseSort;
            return getSortValue((_this4$baseSort = _this4.baseSort) === null || _this4$baseSort === void 0 ? void 0 : _this4$baseSort.field, model);
          };
          sortFn = function sortFn(model) {
            return getSortValue(sortField, model);
          };
        } else {
          baseSortFn = function baseSortFn(model) {
            var _this4$baseSort2;
            return model.getSortValue((_this4$baseSort2 = _this4.baseSort) === null || _this4$baseSort2 === void 0 ? void 0 : _this4$baseSort2.field);
          };
          sortFn = function sortFn(model) {
            return model.getSortValue(sortField);
          };
        }
        if (this.baseSort) {
          iteratees.push(baseSortFn);
          orders.push(this.baseSort.direction || 'asc');
        }
        iteratees.push(sortFn);
        if (sortDir) {
          orders.push(sortDir);
        }
        if (this.secondarySort) {
          iteratees.push(function (model) {
            var _this4$secondarySort;
            return model.getSortValue((_this4$secondarySort = _this4.secondarySort) === null || _this4$secondarySort === void 0 ? void 0 : _this4$secondarySort.field);
          });
          orders.push(this.secondarySort.direction || 'asc');
        }
        this.models.replace(_orderBy(this.models, iteratees, orders));
      }
    }
  }, {
    key: "serverSort",
    value: function serverSort(field, direction) {
      var sortField = this.sortState.field;
      var sortDir = this.sortState.direction;

      // just clear the sort if the user clicked the same field while already sorted descending or sorted by the default direction
      if (this.threeWaySort && sortField === field && sortDir && (this.defaultSortState.direction && sortDir !== this.defaultSortState.direction || !this.defaultSortState.direction && sortDir === 'desc')) {
        this.clearSort(true);
        return;
      }

      // If a field was explicitly passed, use it
      if (field !== undefined) {
        sortField = field;
        sortDir = direction || this.defaultSortState.direction || 'asc';

        // If the field passed was the same as current, toggle the direction (or turn off)
        if (field === this.sortState.field && !direction) {
          sortDir = this.sortState.direction === 'asc' ? 'desc' : 'asc';
        }
      }
      if (sortField) {
        if (this.sortState.field !== sortField || this.sortState.direction !== sortDir) {
          this.sortState = {
            field: sortField,
            direction: sortDir
          };
        }
      }
      if (this.serverSortFn) {
        this.serverSortFn();
      }
    }

    /**
     * Sets the sort state without forcing a sort. Useful to do prior to fetching.
     */
  }, {
    key: "setSortState",
    value: function setSortState(field) {
      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'asc';
      this.sortState = {
        field: field,
        direction: direction
      };
    }
  }, {
    key: "clearSort",
    value: function clearSort(serverSort) {
      this.sortState = {};
      if (this.threeWaySort && !serverSort && this.original) {
        this.set(this.original);
      } else if (serverSort) {
        this.serverSort();
      } else {
        this.sort();
      }
    }

    /**
     * Filter models, finishing with a sort. DO NOT CALL IN A LOOP.
     */
  }, {
    key: "filter",
    value: function filter(query) {
      var _this5 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$immutable = options.immutable,
        immutable = _options$immutable === void 0 ? false : _options$immutable,
        _options$idPath = options.idPath,
        idPath = _options$idPath === void 0 ? 'id' : _options$idPath,
        customFilter = options.customFilter,
        guardForDuplicates = options.guardForDuplicates;
      if (immutable) {
        if (!query) {
          return this.get();
        }
        return this.get().filter(query);
      }
      if (query !== undefined) {
        this.filterState = query;
      }
      this.original = this.get();
      if (customFilter) {
        this.models.replace(this.original.filter(customFilter));
      } else if (this.filterState) {
        if (_isString(this.filterState)) {
          var regex = new RegExp(_escapeRegExp(this.filterState), 'i');
          this.models.replace(this.original.filter(function (model) {
            return _this5.getFilterValues(model).some(function (value) {
              return regex.test(value);
            });
          }));
        } else {
          this.models.replace(this.original.filter(this.filterState));
        }
      } else {
        // this is needed to get initial data in collections when filter is applied on first renders
        this.models.replace(this.get());
      }
      if (this.activePresetFilter) {
        this.models.replace(this.models.filter(this.activePresetFilter.fn));
      }
      this.discreteFilters.forEach(function (filter) {
        _this5.models.replace(_this5.models.filter(filter.fn));
      });
      if (guardForDuplicates) {
        var uniqueIds = [];
        var uniqueModels = this.models.filter(function (model) {
          var id = model.get(idPath);
          var isDuplicate = uniqueIds.includes(id);
          if (!isDuplicate) {
            uniqueIds.push(id);
            return true;
          }
          return false;
        });
        this.models.replace(uniqueModels);
      }
      this.sort();
      return this.models;
    }
  }, {
    key: "setPresetFilter",
    value: function setPresetFilter(filter) {
      this.activePresetFilter = filter;
      this.filter();
    }
  }, {
    key: "resetDiscreteFilters",
    value: function resetDiscreteFilters() {
      this.discreteFilters = this.defaultDiscreteFilters;
    }
  }, {
    key: "setDiscreteFilters",
    value: function setDiscreteFilters(discreteFilters) {
      this.discreteFilters = _toConsumableArray(discreteFilters);
    }
  }, {
    key: "removeDiscreteFilter",
    value: function removeDiscreteFilter(type) {
      this.discreteFilters = this.discreteFilters.filter(function (filter) {
        return filter.type !== type;
      });
    }
  }, {
    key: "clearFilters",
    value: function clearFilters() {
      this.filterState = undefined;
      this.activePresetFilter = null;
      this.discreteFilters = [];
      this.models.replace(this.get());
      this.sort();
    }
  }, {
    key: "hasFilter",
    get: function get() {
      return !!(this.filterState || this.activePresetFilter || this.discreteFilters.length);
    }

    /**
     * Returns an array of values that filters can match against.
     * This can support matching against model properties and any other observables and computed properties.
     * To support observables and computed properties, define the property name in the collection's "filterFieldWhitelist" set.
     */
  }, {
    key: "getFilterValues",
    value: function getFilterValues(model) {
      var _this6 = this;
      var modelKeys = Object.keys(model.attributes);
      var whiteListKeys = this.filterFieldWhitelist && Array.from(this.filterFieldWhitelist);
      var keys = _union(modelKeys, whiteListKeys);
      return keys.filter(function (name) {
        return !_this6.filterFieldBlacklist || !_this6.filterFieldBlacklist.has(name);
      }).filter(function (name) {
        return !_this6.filterFieldWhitelist || _this6.filterFieldWhitelist.has(name);
      }).map(function (name) {
        return model.get(name) || model[name];
      }).filter(function (value) {
        return value !== 'undefined';
      });
    }
  }, {
    key: "filterFieldBlacklist",
    get: function get() {
      return null;
    }
  }, {
    key: "filterFieldWhitelist",
    get: function get() {
      return null;
    }
  }, {
    key: "size",
    get: function get() {
      return this.models.length;
    }
  }, {
    key: "selectedSize",
    get: function get() {
      var _this$selectedArray$l, _this$selectedArray;
      return (_this$selectedArray$l = (_this$selectedArray = this.selectedArray) === null || _this$selectedArray === void 0 ? void 0 : _this$selectedArray.length) !== null && _this$selectedArray$l !== void 0 ? _this$selectedArray$l : 0;
    }
  }, {
    key: "unfilteredSize",
    get: function get() {
      return this.get().length;
    }
  }, {
    key: "unfiltered",
    get: function get() {
      return this.original || this.models;
    }
  }, {
    key: "status",
    get: function get() {
      return this.requestStatus || 'none';
    }
  }, {
    key: "loading",
    get: function get() {
      return this.requestStatus === 'fetching' || this.requestStatus === 'fetchingMore' || this.requestStatus === 'awaitingRequest';
    }
  }, {
    key: "discreteFilterValues",
    get: function get() {
      return this.discreteFilters.reduce(function (acc, f) {
        acc[f.type] = f.value;
        return acc;
      }, {});
    }
  }, {
    key: "isAllSelected",
    get: function get() {
      var _this$models,
        _this$selectedArray2,
        _this7 = this;
      var selectableModels = (_this$models = this.models) === null || _this$models === void 0 ? void 0 : _this$models.filter(function (model) {
        return model.isSelectable;
      });
      return !!(this.selectedArray && ((_this$selectedArray2 = this.selectedArray) === null || _this$selectedArray2 === void 0 ? void 0 : _this$selectedArray2.length) >= (selectableModels === null || selectableModels === void 0 ? void 0 : selectableModels.length) &&
      /** ensure that all the selected models are the same as the models that are currently being displayed.
       * This is useful when the models are paginated, as changing the page will cause the selected.length to be the same as the selectableModels length. */
      selectableModels !== null && selectableModels !== void 0 && selectableModels.every(function (model) {
        var _this7$selectedArray;
        return (_this7$selectedArray = _this7.selectedArray) === null || _this7$selectedArray === void 0 ? void 0 : _this7$selectedArray.find(function (selectedModel) {
          return model.get('id') === selectedModel.get('id');
        });
      }));
    }
  }, {
    key: "sortFieldIsServerSortable",
    get: function get() {
      return !!(this.sortState.field && this.serverSortableFields.includes(this.sortState.field));
    }
  }, {
    key: "sortFieldIsUISortLogicDriven",
    get: function get() {
      return !!(this.sortState.field && this.uiSortLogicFields.includes(this.sortState.field));
    }
  }, {
    key: "groupByFieldIsUISortLogicDriven",
    get: function get() {
      return !!(this.groupBy && this.uiSortLogicFields.includes(this.groupBy));
    }
  }, {
    key: "selectAll",
    value: function selectAll() {
      this.selected = this.isAllSelected ? null : this.models.filter(function (model) {
        return model.isSelectable;
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.models.clear();
      this.original = null;
      this.hasFetched = false;
      this.lastFetched = null;
      this.hasMoreResults = false;
      this.hashModelsById();
      this.requestStatus = null;
      this.fetchPromise = null;
      this.setLastUpdated();
      if (options.hard) {
        this.resetState();
      }
    }
  }, {
    key: "resetState",
    value: function resetState() {
      this.hasMoreResults = false;
      this.filterState = undefined;
      this.activePresetFilter = this.defaultPresetFilter;
      this.discreteFilters = this.defaultDiscreteFilters;
      this.sortState = this.defaultSortState;
      this.groupBy = this.defaultGroupBy;
      this.filter();
    }
  }, {
    key: "resetSortState",
    value: function resetSortState() {
      this.sortState = this.defaultSortState;
      this.sort();
    }
  }, {
    key: "resetFetchCache",
    value: function resetFetchCache() {
      this.lastFetched = null;
    }
  }, {
    key: "processHeaders",
    value:
    /**
     * Can be overridden for more header handling, though note that this is entirely ignored unless
     * you pass `rawResponse` to `fetch()` calls.
     */
    function processHeaders(headers) {
      if (headers['x-total-count'] != null) {
        this.setTotalCount(parseInt(headers['x-total-count']));
      }
    }
  }, {
    key: "processData",
    value: function processData(response) {
      var _response,
        _fetchOptions$data,
        _fetchOptions$data2,
        _response3,
        _fetchOptions$data3,
        _fetchOptions$data4,
        _this8 = this;
      var fetchOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if ((_response = response) !== null && _response !== void 0 && _response.body && fetchOptions.rawResponse) {
        var _response2 = response,
          _response2$headers = _response2.headers,
          headers = _response2$headers === void 0 ? {} : _response2$headers;
        this.processHeaders(headers);
        response = safelyParseJSON(response.body);
      }
      // do not clear original if we're adding more on top of it (for example loading more data via infinite scroll)
      if (!this.useAsyncAdd || !(fetchOptions !== null && fetchOptions !== void 0 && (_fetchOptions$data = fetchOptions.data) !== null && _fetchOptions$data !== void 0 && _fetchOptions$data.offset || fetchOptions !== null && fetchOptions !== void 0 && (_fetchOptions$data2 = fetchOptions.data) !== null && _fetchOptions$data2 !== void 0 && (_fetchOptions$data2 = _fetchOptions$data2.pagination) !== null && _fetchOptions$data2 !== void 0 && _fetchOptions$data2.offset)) {
        this.original = [];
      }
      this.hasMoreResults = (_response3 = response) === null || _response3 === void 0 || (_response3 = _response3.pagination) === null || _response3 === void 0 ? void 0 : _response3.has_more_results;
      var data = response ? this.deserialize(response) : [];
      if (this.useAsyncAdd || fetchOptions !== null && fetchOptions !== void 0 && (_fetchOptions$data3 = fetchOptions.data) !== null && _fetchOptions$data3 !== void 0 && _fetchOptions$data3.offset || fetchOptions !== null && fetchOptions !== void 0 && (_fetchOptions$data4 = fetchOptions.data) !== null && _fetchOptions$data4 !== void 0 && (_fetchOptions$data4 = _fetchOptions$data4.pagination) !== null && _fetchOptions$data4 !== void 0 && _fetchOptions$data4.offset) {
        var models = [];
        return processLargeArrayAsync(data, function (row) {
          models = models.concat(_this8.build(row));
        }).then(action(function () {
          _this8.original = _this8.get().concat(models);
          _this8.filter(undefined, {
            idPath: fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.idPath,
            guardForDuplicates: fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.pagedFetch
          });
          _this8.setLastUpdated();
          _this8.hashModelsById();
          return response;
        }));
      }
      this.set(data);
      return Promise.resolve(response);
    }
  }, {
    key: "canReuseFetch",
    value: function canReuseFetch(options, label) {
      return !!(!options.pagedFetch && !options.query && !options.force && (this.requestStatus === label && this.fetchPromise || this.lastFetched && this.lastFetched > Date.now() - this.minFetchInterval));
    }

    /**
     * Fetches collection data from the backend and overwrites the models, applying filter/sorts/groups.
     */
  }, {
    key: "fetch",
    value: (function () {
      var _fetch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this9 = this;
        var options,
          preserveSelection,
          label,
          count,
          _args = arguments;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              preserveSelection = options.preserveSelection; // fetching more in case we're doing a paged fetch, to update the UI somehow, indicate to the user we are loading more
              label = options.pagedFetch ? 'fetchingMore' : 'fetching';
              if (options.pagedFetch) {
                this.useAsyncAdd = true;
              }

              // Never fetch if already fetching or if too recent - unless parameters are diff
              if (!(this.canReuseFetch(options, label) && _isEqual(options.data, this.lastData))) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return", this.fetchPromise);
            case 1:
              this.lastFetched = Date.now();
              this.requestStatus = label;
              this.hasFetched = true;
              this.fetchCount += 1;
              this.lastData = options.data;
              count = this.fetchCount;
              if (!preserveSelection) {
                this.clearSelection();
              }
              this.fetchPromise = this.doFetch(options, label).then(function (response) {
                // ensure that we only display the last result if we make multiple fetches (i.e. due to options.force)
                if (_this9.fetchCount === count) {
                  return _this9.processData(response, options);
                }
                // this.fetchPromise will always contain the latest attempt so we can simply chain that
                return _this9.fetchPromise;
              }, function (error) {
                if (_this9.fetchCount === count) {
                  _this9.error = {
                    label: label,
                    body: error
                  };
                  _this9.models.clear();
                  _this9.hashModelsById();
                  _this9.fetchPromise = null;
                }
                throw error;
              })["finally"](function () {
                if (_this9.fetchCount === count) {
                  _this9.requestStatus = null;
                }
              });
              return _context.abrupt("return", this.fetchPromise);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetch() {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }())
  }, {
    key: "getCacheKey",
    value: function getCacheKey(data) {
      return JSON.stringify(data);
    }
  }, {
    key: "getCachedValue",
    value: function getCachedValue(cacheOptions) {
      return this.cachedResults.get(this.getCacheKey(cacheOptions));
    }
  }, {
    key: "saveToCache",
    value: function saveToCache(result, cacheOptions) {
      this.cachedResults.set(this.getCacheKey(cacheOptions), result);
    }

    /**
     * Just performs the actual data fetching. This method can be overridden for custom fetch mechanisms.
     */
  }, {
    key: "doFetch",
    value: (function () {
      var _doFetch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$urlPaths,
          _this0 = this;
        var options,
          label,
          cachedValue,
          data,
          fetchUrl,
          fetchMethod,
          query,
          rawResponse,
          httpMethod,
          url,
          _args2 = arguments;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              options = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
              label = _args2.length > 1 ? _args2[1] : undefined;
              if (!(options.withCache && this.canReuseFetch(options, label))) {
                _context2.next = 1;
                break;
              }
              cachedValue = this.getCachedValue(options);
              if (!cachedValue) {
                _context2.next = 1;
                break;
              }
              return _context2.abrupt("return", Promise.resolve(cachedValue));
            case 1:
              data = options.data, fetchUrl = options.fetchUrl, fetchMethod = options.fetchMethod, query = options.query, rawResponse = options.rawResponse;
              httpMethod = fetchMethod || this.fetchMethod;
              url = fetchUrl || ((_this$urlPaths = this.urlPaths) !== null && _this$urlPaths !== void 0 && _this$urlPaths.fetch ? this.urlPaths.fetch : this.url);
              if (url) {
                _context2.next = 2;
                break;
              }
              throw new Error('Could not find URL for Collection fetch!');
            case 2:
              return _context2.abrupt("return", api[httpMethod](url, {
                data: data,
                query: query,
                rawResponse: rawResponse
              }).then(function (result) {
                if (options.withCache) {
                  _this0.saveToCache(result, options);
                }
                return result;
              }));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function doFetch() {
        return _doFetch.apply(this, arguments);
      }
      return doFetch;
    }())
  }, {
    key: "queuedFetch",
    value: (
    /**
     * This is very similar to fetch but allows for multiple fetch requests to go out at same time, but ONLY
     * last one will actually update the collection with results (paging, server-based collection filtering, etc.)
     */
    function () {
      var _queuedFetch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this1 = this;
        var options,
          data,
          fetchUrl,
          fetchMethod,
          preserveSelection,
          query,
          label,
          key,
          qfHttpMethod,
          qfUrl,
          _collatePromises,
          masterPromise,
          queue,
          _args3 = arguments;
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              options = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
              data = options.data, fetchUrl = options.fetchUrl, fetchMethod = options.fetchMethod, preserveSelection = options.preserveSelection, query = options.query;
              label = 'fetching';
              this.requestStatus = label;
              this.hasFetched = true;
              this.useAsyncAdd = false;
              if (!preserveSelection) {
                this.clearSelection();
              }
              key = this.queuedFetchKey;
              if (key) {
                _context3.next = 1;
                break;
              }
              return _context3.abrupt("return", Promise.reject(new Error('Collection must provide queuedFetchKey')));
            case 1:
              qfHttpMethod = fetchMethod || this.fetchMethod;
              qfUrl = fetchUrl || (this.urlPaths && this.urlPaths.fetch ? this.urlPaths.fetch : this.url);
              if (qfUrl) {
                _context3.next = 2;
                break;
              }
              throw new Error('Could not fetch Collection with missing qfUrl');
            case 2:
              _collatePromises = collatePromises({
                key: key,
                promise: api[qfHttpMethod](qfUrl, {
                  data: data,
                  query: query
                })
              }), masterPromise = _collatePromises.masterPromise, queue = _collatePromises.queue;
              if (!(queue.length > 1)) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return", masterPromise);
            case 3:
              return _context3.abrupt("return", masterPromise.then(function (results) {
                return _this1.processData(results);
              }, function (error) {
                _this1.error = {
                  label: label,
                  body: error
                };
                _this1.models.clear();
                _this1.hashModelsById();
                throw error;
              })["finally"](function () {
                _this1.requestStatus = null;
              }));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function queuedFetch() {
        return _queuedFetch.apply(this, arguments);
      }
      return queuedFetch;
    }())
  }, {
    key: "bulkUpdate",
    value: function () {
      var _bulkUpdate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(name, value) {
        var _this$urlPaths2,
          _this10 = this;
        var selectedArray, url, ids, data;
        return _regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              selectedArray = this.selectedArray;
              url = this.url || ((_this$urlPaths2 = this.urlPaths) === null || _this$urlPaths2 === void 0 ? void 0 : _this$urlPaths2.fetch);
              if (!(!(selectedArray !== null && selectedArray !== void 0 && selectedArray.length) || !url)) {
                _context4.next = 1;
                break;
              }
              return _context4.abrupt("return", null);
            case 1:
              ids = selectedArray === null || selectedArray === void 0 ? void 0 : selectedArray.map(function (model) {
                return model.id;
              });
              data = {
                ids: ids,
                name: name,
                value: value
              };
              this.setRequestStatus('updating');
              return _context4.abrupt("return", api.post("".concat(url, "/bulkUpdate"), {
                data: data
              }).then(function (results) {
                var _results$;
                if (Array.isArray(results) && (_results$ = results[0]) !== null && _results$ !== void 0 && _results$.id) {
                  // received an array of updated models, so update models directly
                  results.forEach(function (result) {
                    var model = _this10.get(result.id);
                    if (model) {
                      model.set(model.deserialize(result));
                    }
                  });
                } else {
                  // didn't receive full updated data, so just update the specific field
                  selectedArray.forEach(function (model) {
                    model.set(name, value);
                  });
                }
                _this10.setRequestStatus(null);
              }));
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function bulkUpdate(_x, _x2) {
        return _bulkUpdate.apply(this, arguments);
      }
      return bulkUpdate;
    }()
  }, {
    key: "bulkDelete",
    value: function () {
      var _bulkDelete = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this$urlPaths3,
          _this11 = this;
        var _ref3,
          _ref3$removeFromColle,
          removeFromCollection,
          selectedArray,
          url,
          ids,
          data,
          _args5 = arguments;
        return _regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _ref3 = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {}, _ref3$removeFromColle = _ref3.removeFromCollection, removeFromCollection = _ref3$removeFromColle === void 0 ? true : _ref3$removeFromColle;
              selectedArray = this.selectedArray;
              url = this.url || ((_this$urlPaths3 = this.urlPaths) === null || _this$urlPaths3 === void 0 ? void 0 : _this$urlPaths3.fetch);
              if (!(!(selectedArray !== null && selectedArray !== void 0 && selectedArray.length) || !url)) {
                _context5.next = 1;
                break;
              }
              return _context5.abrupt("return", null);
            case 1:
              ids = selectedArray === null || selectedArray === void 0 ? void 0 : selectedArray.map(function (model) {
                return model.id;
              });
              data = {
                ids: ids
              };
              this.setRequestStatus('updating');
              return _context5.abrupt("return", api.post("".concat(url, "/bulkDelete"), {
                data: data
              }).then(function (result) {
                if (removeFromCollection) {
                  _this11.remove(ids);
                }
                _this11.clearSelection();
                _this11.setRequestStatus(null);
                return result;
              }));
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function bulkDelete() {
        return _bulkDelete.apply(this, arguments);
      }
      return bulkDelete;
    }()
  }, {
    key: "serialize",
    value: function serialize(data) {
      return data || this.map(function (model) {
        return model.serialize();
      });
    }
  }, {
    key: "jsonRoot",
    get: function get() {
      return undefined;
    }
  }, {
    key: "deserialize",
    value: function deserialize(data) {
      // @ts-expect-error this.jsonRoot isn't really something we can map easily
      return data && this.jsonRoot ? data[this.jsonRoot] : data;
    }
  }, {
    key: "setTotalCount",
    value: function setTotalCount(totalCount) {
      this.totalCount = totalCount;
    }
  }]);
}(), _descriptor = _applyDecoratedDescriptor(_class.prototype, "requestStatus", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "error", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "filterState", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "activePresetFilter", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "discreteFilters", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "sortState", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "groupBy", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "selected", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "selectedArray", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedArray"), _class.prototype), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "hasFetched", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "original", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "lastUpdated", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "lastFetched", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "useAsyncAdd", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "totalCount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "hasMoreResults", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "fetchCount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "cachedResults", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return new Map();
  }
}), _applyDecoratedDescriptor(_class.prototype, "group", [action], Object.getOwnPropertyDescriptor(_class.prototype, "group"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "move", [action], Object.getOwnPropertyDescriptor(_class.prototype, "move"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sort", [action], Object.getOwnPropertyDescriptor(_class.prototype, "sort"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "serverSort", [action], Object.getOwnPropertyDescriptor(_class.prototype, "serverSort"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSortState", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSortState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearSort", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clearSort"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "filter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPresetFilter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPresetFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetDiscreteFilters", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resetDiscreteFilters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setDiscreteFilters", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setDiscreteFilters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeDiscreteFilter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeDiscreteFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearFilters", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clearFilters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasFilter", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "size", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "size"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedSize", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedSize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unfilteredSize", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "unfilteredSize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unfiltered", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "unfiltered"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "status", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "status"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "loading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "discreteFilterValues", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "discreteFilterValues"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAllSelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAllSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sortFieldIsServerSortable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortFieldIsServerSortable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sortFieldIsUISortLogicDriven", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortFieldIsUISortLogicDriven"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "groupByFieldIsUISortLogicDriven", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "groupByFieldIsUISortLogicDriven"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectAll", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectAll"), _class.prototype), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "unselectAll", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this12 = this;
    return function () {
      _this12.selected = null;
    };
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "select", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this13 = this;
    return function (model) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$multi = options.multi,
        multi = _options$multi === void 0 ? false : _options$multi,
        shiftKey = options.shiftKey;
      var m = model && _this13.get(model.id);
      if (!m) {
        console.warn("Model (id: ".concat(model && model.id, ") not found in ").concat(_this13.constructor.name));
      }
      if (multi) {
        if (!_this13.selected || !Array.isArray(_this13.selected)) {
          _this13.selected = [];
        }
        if (model.isSelected) {
          var indexOfModel = _this13.selected.indexOf(model);
          if (indexOfModel >= 0) {
            _this13.selected = _this13.selected.slice(0, indexOfModel).concat(_this13.selected.slice(indexOfModel + 1));
          }
          if (_this13.selected.length === 0) {
            _this13.selected = null;
          }

          // adding to a multi selection
        } else {
          // select all the models in between
          if (shiftKey) {
            var _document$getSelectio;
            var firstIndex = _this13.selected[0].index;
            if (firstIndex > model.index) {
              _this13.selected = _this13.models.slice(model.index, firstIndex + 1).filter(function (item) {
                return item.isSelectable;
              });
            } else {
              _this13.selected = _this13.models.slice(firstIndex, model.index).filter(function (item) {
                return item.isSelectable;
              });
            }

            // Browsers (on some platforms) will try to select text in between the 2 cursor points. Revert that.
            (_document$getSelectio = document.getSelection()) === null || _document$getSelectio === void 0 || _document$getSelectio.removeAllRanges();
          }
          _this13.selected = _this13.selected.concat(model);
        }
      } else {
        _this13.selected = model;
      }
    };
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "clearSelection", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this14 = this;
    return function () {
      _this14.selected = null;
    };
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "setLastUpdated", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this15 = this;
    return function () {
      _this15.lastUpdated = Date.now();
    };
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "setLastFetched", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this16 = this;
    return function (when) {
      _this16.lastFetched = when || Date.now();
    };
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "setRequestStatus", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this17 = this;
    return function (status) {
      _this17.requestStatus = status;
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "reset", [action], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetState", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resetState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetSortState", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resetSortState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetFetchCache", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resetFetchCache"), _class.prototype), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "add", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this18 = this;
    return function (data) {
      if (!_isArray(data)) {
        data = [data];
      }
      var models = data.map(function (row) {
        if (row instanceof Model) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          row.collection = _this18;
          return row;
        }
        return _this18.build(row);
      });
      _this18.original = _this18.get().concat(models);
      _this18.filter();
      _this18.hashModelsById();
      _this18.setLastUpdated();
      return models;
    };
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "remove", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this19 = this;
    return function (ids) {
      var destroyModels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (Array.isArray(ids)) {
        ids.forEach(function (id) {
          return _this19.remove(id, destroyModels);
        });
      } else {
        var _model = _this19.get(ids);
        if (_model) {
          var _this19$selected;
          if (_this19.original) {
            _this19.original = _this19.original.filter(function (m) {
              return m !== _model;
            });
          }
          _this19.models.remove(_model);
          if (destroyModels) {
            _model.destroy();
          }
          // TODO support clearing multi-select
          if (!Array.isArray(_this19.selected) && ((_this19$selected = _this19.selected) === null || _this19$selected === void 0 ? void 0 : _this19$selected.id) === _model.id) {
            _this19.clearSelection();
          }
        }
      }
      _this19.hashModelsById();
      _this19.setLastUpdated();
    };
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "set", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this20 = this;
    return function (models) {
      // This is a hack to pretend to clear out the existing data and append the new models w/o triggering two observed changes to this.models
      _this20.original = [];
      _this20.add(models);
      _this20.setLastUpdated();
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "processHeaders", [action], Object.getOwnPropertyDescriptor(_class.prototype, "processHeaders"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "processData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "processData"), _class.prototype), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "forge", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this21 = this;
    return function (attributes) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$select2 = options.select,
        select = _options$select2 === void 0 ? true : _options$select2;
      return (attributes === null || attributes === void 0 ? void 0 : attributes.id) && _this21.get(attributes.id) || _this21.build(attributes, _objectSpread(_objectSpread({}, options), {}, {
        select: select
      }));
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "fetch", [action], Object.getOwnPropertyDescriptor(_class.prototype, "fetch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "queuedFetch", [action], Object.getOwnPropertyDescriptor(_class.prototype, "queuedFetch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setTotalCount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setTotalCount"), _class.prototype), _class);

/**
 * A concrete, non-generic version of the Collection class that can be
 * easily instantiated from JavaScript files.
 *
 * @deprecated for future code it is generally preferable to create your own type-safe Collection
 */
var GenericCollection = /*#__PURE__*/function (_Collection2) {
  function GenericCollection() {
    _classCallCheck(this, GenericCollection);
    return _callSuper(this, GenericCollection, arguments);
  }
  _inherits(GenericCollection, _Collection2);
  return _createClass(GenericCollection, [{
    key: "model",
    get:
    // Provide a default implementation for the model getter
    function get() {
      return GenericModel;
    }
  }]);
}(Collection);
export { GenericCollection as default };